import { createFileRoute } from '@tanstack/react-router';
import { PageHeader, Stack } from '@leanin/ui';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';
import { BroadcastComposerForm } from '@/components/broadcasts/BroadcastComposerForm';

export const Route = createFileRoute('/_authed/admin/broadcasts/new/')({
  component: NewBroadcastPage,
});

function NewBroadcastPage() {
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="broadcasts">
      <Stack gap="xl">
        <PageHeader
          back={{ href: '/admin/broadcasts', label: 'Admin Panel · Communications' }}
          title="New broadcast"
          subtitle="Email a circle, network, or the whole community. Schedule for later or send now."
        />
        <BroadcastComposerForm audience={{ mode: 'platform' }} />
      </Stack>
    </AdminShell>
  );
}
